import Cookies from 'js-cookie';
import FetchData from '../Components/ServerCall/FetchData';

const getHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${Cookies.get('authToken')}`,
});

/**
 * Fetches specific connection details
 */
export async function getWebApiConnectionDetails(connectionId: string, workspaceId: string) {
  const res = await FetchData({
    requestType: 'noData',
    method: 'GET',
    url: `database-connection/${connectionId}?workspaceId=${workspaceId}`,
    headers: getHeaders(),
  });

  if (!res.status) {
    return {
      isError: true,
      message: res.error || res.data?.message || 'Failed to load connection details',
      data: null,
    };
  }
  return { isError: false, data: res.data };
}

/**
 * Tests a Web API connection configuration
 */
export async function testWebApiConnection(webAPIString: string) {
  const res = await FetchData({
    requestType: 'withData',
    method: 'POST',
    url: 'webapi-connection-test',
    headers: getHeaders(),
    data: { webAPI: webAPIString },
  });

  if (!res.status) {
    return {
      isError: true,
      message: res.error || res.data?.message || 'Test Connection Failed',
      data: null,
    };
  }
  return { isError: false, data: res.data };
}

/**
 *
 * @returns workspace and subworkspace tree with web api connection
 */
export async function getWebApiConnectionTree() {
  const res = await FetchData({
    requestType: 'withData',
    method: 'GET',
    url: 'webapi/tree',
    headers: getHeaders(),
  });
  if (!res.status) {
    return {
      isError: true,
      message: (res.data.message ?? 'Failed to get web API connection tree') as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Web API connection tree fetched successfully',
    data: res.data,
  };
}

/**
 *
 * @returns  web api response for a selected connection ID
 */
export async function getWebApiResponse(connectionId: string) {
  const res = await FetchData({
    requestType: 'noData',
    method: 'GET',
    url: `webapi?connectionId=${connectionId}`,
    headers: getHeaders(),
  });
  if (!res.status) {
    return {
      isError: true,
      message: (res.data.message ?? 'Failed to fetch web API response') as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Web API response fetched successfully',
    data: res.data,
  };
}

/**
 * Saves or Updates a Web API connection
 */
export async function saveWebApiConnection(
  workspaceId: string, 
  connectionName: string, 
  webAPIString: string, 
  connectionId?: string 
) {
  const isUpdate = !!connectionId;
  const url = isUpdate 
    ? `database-connection/${connectionId}?workspaceId=${workspaceId}` 
    : `database-connection?workspaceId=${workspaceId}`;

  const res = await FetchData({
    requestType: 'withData',
    method: isUpdate ? 'PUT' : 'POST',
    url: url,
    headers: getHeaders(),
    data: {
      vendor: 'webapi',
      connectionName,
      webAPI: webAPIString,
      server: null,
      port: null,
      database: null,
      username: '',
      password: '',
      httpPath: null,
      projectId: null,
      clientEmail: null,
      region: null,
      s3Location: null,
    },
  });

  if (!res.status) {
    return {
      isError: true,
      message: res.data?.detail || res.data?.message || 'Failed to save connection',
      data: null,
    };
  }

  return { isError: false, data: res.data };
}
